module.exports = __webpack_public_path__ + "static/media/53.2909f293.png";